import { AnchorLink, media } from '@displate/styleguide';
import Link from 'next/link';
import styled, { css } from 'styled-components';

import {
  HORIZONTAL_IMAGE_RATIO,
  HORIZONTAL_IMAGE_RATIO_1920,
  HORIZONTAL_IMAGE_RATIO_SM,
  HORIZONTAL_IMAGE_RATIO_XL,
  VERTICAL_IMAGE_RATIO,
} from '@/common/components/ArtworkPicture/artwork';
import { WishlistButtonStyled } from '@/common/components/WishlistButton/WishlistButton.styled';
import { customMediaQueries } from '@/common/constants/customMediaQueries';
import { ArtworkOrientation } from 'generatedBfw/static';

export const LinkAllPosters = styled(AnchorLink)`
  color: ${({ theme }) => theme.colorsV2.font.textWhite};
`;

export const NextLinkAllPosters = styled(Link)`
  color: ${({ theme }) => theme.colorsV2.font.textWhite};
  text-decoration: none;
`;

export const WishlistButtonWrapper = styled.div`
  position: absolute;
  right: 8px;
  top: 8px;
  z-index: 1;

  ${WishlistButtonStyled} {
    ${media.medium} {
      display: none;
    }

    background-color: rgba(165, 165, 165, 0.5);
    &:hover {
      background-color: rgba(165, 165, 165, 0.5);
    }
    &.is-in-wishlist,
    &.is-adding-to-wishlist {
      display: flex;
    }
  }
`;

export const MasonryGridItemContainer = styled.div<{ $orientation: ArtworkOrientation }>`
  position: relative;
  grid-row-end: ${({ $orientation }) =>
    $orientation === ArtworkOrientation.HORIZONTAL ? 'span 1' : 'span 2'};
  box-shadow: ${({ theme }) => theme.shadows.medium};
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  border-radius: 2px;
  overflow: hidden;
  transition: 0.2s ease-in-out;
  aspect-ratio: ${({ $orientation }) =>
    $orientation === ArtworkOrientation.VERTICAL ? VERTICAL_IMAGE_RATIO : HORIZONTAL_IMAGE_RATIO};

  .masonryGridItemLink {
    display: flex;
    height: 100%;
  }

  img {
    will-change: transform;
    transition: 0.2s ease-in-out;
  }

  ${({ $orientation }) =>
    $orientation === ArtworkOrientation.HORIZONTAL &&
    css`
      position: relative;
      aspect-ratio: ${HORIZONTAL_IMAGE_RATIO};

      a {
        display: flex;
        height: 100%;
        width: 100%;
      }

      ${media.small} {
        aspect-ratio: ${HORIZONTAL_IMAGE_RATIO_SM};
      }

      ${media.xLarge} {
        aspect-ratio: ${HORIZONTAL_IMAGE_RATIO_XL};
      }

      ${customMediaQueries.width1920} {
        aspect-ratio: ${HORIZONTAL_IMAGE_RATIO_1920};
      }
    `}

  &:hover {
    box-shadow: 0px 10px 30px 0px rgba(16, 17, 26, 0.4);

    img {
      transform: scale(1.03);
    }

    ${WishlistButtonStyled} {
      display: flex;
    }
  }

  ${media.small} {
    min-width: 20vw;
  }

  ${media.medium} {
    &:hover ${WishlistButtonWrapper} {
      display: block;
    }
  }

  ${media.large} {
    min-width: 15vw;
  }
  ${media.xLarge} {
    min-width: 12vw;
  }

  ${customMediaQueries.width1920} {
    min-width: unset;
  }
`;

export const MasonryGridImageWrapper = styled.div`
  display: flex;
  width: 100%;
`;
